<!-- ----------------------------------------------- -->
<template>
  <div class="legend-content">
    <v-container style="align-items:center">
      <v-row class="no-gutters" align-content="center">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.damdschPrevop" style="height: 30px;" />
        </v-col>
        <v-col :cols="9" align-self="center">
          <div class="location-text pl-2" style="line-height: 1.2">
            {{ text.damdschPrevop }}
          </div>
        </v-col>
      </v-row>
      <v-row class="no-gutters" align-content="center">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.damdschStorop" style="height: 30px;" />
        </v-col>
        <v-col :cols="9" align-self="center">
          <div class="location-text pl-2">
            {{ text.damdschStorop }}
          </div>
        </v-col>
      </v-row>
      <v-row class="no-gutters" align-content="center">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.damdschNormal" style="height: 30px;" />
        </v-col>
        <v-col :cols="9" align-self="center">
          <div class="location-text pl-2">
            {{ text.damdschNormal }}
          </div>
        </v-col>
      </v-row>
      <v-row class="no-gutters" align-content="center">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.damdschMissing" style="height: 30px;" />
        </v-col>
        <v-col :cols="9" align-self="center">
          <div class="location-text pl-2">
            {{ text.damdschMissing }}
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col></v-col>
      </v-row>
      <v-row class="no-gutters" align-content="center">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.damdschNotset" style="height: 30px;" />
        </v-col>
        <v-col :cols="9">
          <div class="location-text pl-2" style="line-height: 1.2">
            {{ text.damdschNotset }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 地図凡例ダイアログ ダム放流通知
 * LegendDamdsch.vue
 * @author LIS
 */
export default {
  name: "legend-damdsch",
  data() {
    return {
      /** アイコン */
      imgResource: {
        damdschPrevop: "/kawabou/img/map_icons/obs_dam_abnormal.svg",
        damdschStorop: "/kawabou/img/map_icons/obs_dam_storage.svg",
        damdschNormal: "/kawabou/img/map_icons/obs_dam_normal.svg",
        damdschMissing: "/kawabou/img/map_icons/obs_dam_missing.svg",
        damdschNotset: "/kawabou/img/map_icons/obs_dam_notset.svg",
      },
      /** 文字列リソース */
      text: {
        damdschPrevop: "緊急放流　実施の可能性あり・実施予定・実施中",
        damdschStorop: "洪水調節　実施中",
        damdschNormal: "平常",
        damdschMissing: "欠測",
        damdschNotset: "白色のダムは、放流の状況による表示色の変化はいたしません。",
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.legend-content {
  width: 250px;
  .location-img {
    display: flex;
    justify-content: flex-end;
    position: relative;
    .badge {
      // position: absolute;
      top: -3px;
      right: 0px;
    }
  }
  .location-text {
    font-size: 0.85rem;
    color: black;
  }
}
</style>
